import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';

import HelpText from '../../components/help/HelpText';
import NoticeBox from '../../components/shared/NoticeBox';

import { adminUser, capitalize, renderErrorWarning, renderErrors } from '../../utilities/Forms.js'
import { request, handleRequestErrors } from '../../helpers/Requests'

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class LocationSettings extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleNestedChange = this.handleNestedChange.bind(this);
    this.handleArrayNestedChange = this.handleArrayNestedChange.bind(this);
    this.handleAddDate = this.handleAddDate.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleRemoveDate = this.handleRemoveDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    locations: [],
    selected_location: "",

    open_hours: {},
    special_hours: [],
    booking_form: false,
    booking_form_urls: {},

    deposits: false,
    deposit_percentage: 10,
    deposit_threshold: 0,
    hours_in_advance: "",

    loaded: false,
    locationsLoaded: false,
    locationLoading: null,
    locationLoaded: false,
    updating: false,

    open_hours_created: null,
    service_created: null,
    service_assigned_staff: null,
    bookingFormCheckLoaded: false,

    unauthorized: "",
    error: "",
    errors: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});

    if (name === "selected_location" && value !== "") {
      this.fetchData(value)
      this.bookingFormCheck(value)
    }
  }

  handleCheckbox(event) {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState({[name]: value});
  }

  handleNestedChange(event) {
    const { name, value, type, checked, dataset } = event.target
    const { day, state } = dataset

    this.setState(prevState => ({
      [state]: {
        ...(prevState[state] || {}),
        [day]: {
          ...(prevState[state]?.[day] || {}),
          [name]: type === "checkbox" ? checked : value
        }
      }
    }));
  }

  handleArrayNestedChange(event) {
    let chosenIndex = parseInt(event.target.parentNode.parentNode.id);
    const { name, value, type, checked, dataset } = event.target
    const { state } = dataset

    this.setState(prevState => {
      let newState = prevState[state]

      newState[chosenIndex][1][name] = type === "checkbox" ? checked : value

      return ({ [state]: newState })
    });
  }

  handleChangeDate(event) {
    let chosenIndex = parseInt(event.target.parentNode.parentNode.id);
    let value = event.target.value;

    const special_hours = this.state.special_hours.map((special_hour, index) => {
      if (index === chosenIndex) {
        return [value, special_hour[1]]
      }
      else {
        return special_hour
      }
    })

    this.setState({ special_hours: special_hours });
  }

  handleAddDate(event) {
    this.setState((prevState) => ({
      special_hours: [...prevState.special_hours, ["", { start: null, finish: null, open: false }]]
    }))

    event.preventDefault();
  }

  handleRemoveDate(event) {
    let chosenIndex = parseInt(event.target.parentNode.parentNode.id);

    let newSpecialHours = this.state.special_hours;
    newSpecialHours.splice(chosenIndex, 1)

    this.setState({ special_hours: newSpecialHours });

    event.preventDefault();
  }

  handleSubmit(event) {
    this.setState({
      updating: true
    })

    const json = JSON.stringify({
      "location_settings": {
        "open_hours": this.state.open_hours,
        "special_hours": this.arrayToObject(this.state.special_hours),
        "booking_form": this.state.booking_form,
        "deposit_percentage": this.deposit_percentage(),
        "deposit_threshold": this.state.deposit_threshold,
        "hours_in_advance": this.state.hours_in_advance
      }
    })

    request('PUT', `/v1/a/location_settings/${this.state.selected_location}`, json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          special_hours: this.objectToArray(data.special_hours),
          updating: false,
          errors: "",
        })

        this.bookingFormCheck(this.state.selected_location)

        sessionStorage.setItem("updateSuccess", `Location Settings updated successfully!`);
        this.props.updatePopupCallback(Math.random())
      })
      .catch(error => handleRequestErrors(this, error, { updating: false }))

    event.preventDefault();
  }

  deposit_percentage() {
    if (this.state.deposits === false) {
      return null
    }

    if (this.state.deposit_percentage === "") {
      return 0
    }

    return this.state.deposit_percentage
  }

  objectToArray(special_hours) {
    return Object.entries(special_hours)
  }

  arrayToObject(special_hours) {
    return Object.fromEntries(special_hours)
  }

  fetchData(selected_location) {
    this.setState({locationLoading: true})

    request('GET', `/v1/a/location_settings/${selected_location}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          open_hours: data.open_hours,
          special_hours: this.objectToArray(data.special_hours || {}),
          booking_form: data.booking_form,
          booking_form_urls: data.booking_form_urls,
          deposits: data.deposit_percentage !== null,
          deposit_percentage: data.deposit_percentage || 10,
          deposit_threshold: data.deposit_threshold || 0,
          hours_in_advance: data.hours_in_advance || 0,
          locationLoaded: true,
          locationLoading: false
        })
      })
      .catch(error => handleRequestErrors(this, error, { locationLoaded: true }))
  }

  bookingFormCheck(selected_location) {
    request('GET', `/v1/a/location_settings/${selected_location}/booking_form_check`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          open_hours_created: data.open_hours_created,
          service_created: data.service_created,
          service_assigned_staff: data.service_assigned_staff,
          bookingFormCheckLoaded: true
        })
      })
      .catch(error => handleRequestErrors(this, error, { bookingFormCheckLoaded: true }))
  }

  renderOpenHoursInputs(day) {
    const data = this.state.open_hours === null ? {} : this.state.open_hours[day]

    const start = data?.start || ""
    const finish = data?.finish || ""
    const open = data?.open || false

    return (
      <tr key={day}>
        <td>
          {capitalize(day)}
        </td>
        <td className="center-cell">
          <input className="column" type="checkbox" name="open" data-day={day} data-state="open_hours" checked={open} onChange={this.handleNestedChange} />
        </td>
        <td className="center-cell">
          <input className="column" type="time" name="start" data-day={day} data-state="open_hours" value={start} disabled={open === false} onChange={this.handleNestedChange} />
        </td>
        <td className="center-cell">
          <input className="column" type="time" name="finish" data-day={day} data-state="open_hours" value={finish} disabled={open === false} onChange={this.handleNestedChange} />
        </td>
      </tr>
    )
  }

  renderSpecialHoursInputs(entry, index) {
    const data = entry[1]

    const date = entry[0]
    const start = data?.start || ""
    const finish = data?.finish || ""
    const open = data?.open || false

    return (
      <tr key={index} id={index}>
        <td className="center-cell">
          <input className="column" type="date" name="key" value={date} onChange={this.handleChangeDate} />
        </td>
        <td className="center-cell">
          <input className="column" type="checkbox" name="open" data-state="special_hours" checked={open} onChange={this.handleArrayNestedChange} />
        </td>
        <td className="center-cell">
          <input className="column" type="time" name="start" data-state="special_hours" value={start} disabled={open === false} onChange={this.handleArrayNestedChange} />
        </td>
        <td className="center-cell">
          <input className="column" type="time" name="finish" data-state="special_hours" value={finish} disabled={open === false} onChange={this.handleArrayNestedChange} />
        </td>
        <td className="center-cell">
          <div className="remove-button" onClick={this.handleRemoveDate}>Remove <FontAwesomeIcon icon={faTimes} /></div>
        </td>
      </tr>
    )
  }

  renderBookingFormWarnings() {
    const { open_hours_created, service_created, service_assigned_staff, booking_form, bookingFormCheckLoaded } = this.state;

    if (booking_form === false || bookingFormCheckLoaded === false) {
      return null
    }

    if (open_hours_created === false || service_created === false || service_assigned_staff === false) {
      return (
        <NoticeBox type="info">
          <div>Your booking form has been enabled, but:
            <ul>
              {open_hours_created === false && <li>You haven't set Open Hours yet. Add them below.</li>}
              {service_created === false && <li>You haven't created any Services yet. Create some <Link target="_blank" to={"/configuration/services"}>here</Link>.</li>}
              {service_assigned_staff === false && <li>Your Services do not have Staff from this Location assigned to them. Please do so <Link target="_blank" to={"/configuration/services"}>here</Link>.</li>}
            </ul>
          </div>
        </NoticeBox>
      )
    }
  }

  renderBookingForm() {
    const { booking_form, booking_form_urls, deposits, deposit_percentage, deposit_threshold, hours_in_advance, selected_location, locationLoading, locationLoaded, errors } = this.state;

    if (locationLoading === true) {
      return <p>Loading ...</p>
    }

    if (locationLoaded === true && selected_location) {
      return (
        <>
          <div className="row">
            <HelpText page={'location_settings'} section={'booking_form'} />

            <label className="column">Booking Form:</label>{ renderErrors(errors, 'booking_form') }
          </div>

          <div className="row padding-bottom">
            <input className="column small-bottom-margin" type="checkbox" name="booking_form" id="booking_form" checked={booking_form} onChange={this.handleCheckbox} />
            <label className="column checkbox-label" htmlFor="booking_form">Enable Booking Form?</label>
          </div>

          {booking_form === true && (
            <>
              <div className="row padding-bottom">
                <HelpText page={'location_settings'} section={'deposits'} />

                <input className="column small-bottom-margin" type="checkbox" name="deposits" id="deposits" checked={deposits} onChange={this.handleCheckbox} />
                <label className="column checkbox-label" htmlFor="deposits">Require Deposits?</label>{ renderErrors(errors, 'deposits') }
                {
                  deposits === true && (
                    <>
                      <div className="row">
                        <HelpText page={'location_settings'} section={'deposit_percentage'} />
                        <label className="column checkbox-label block" htmlFor="deposit_percentage">Deposit Percentage</label>{ renderErrors(errors, 'deposit_percentage') }
                        <input className="column short-input small-bottom-margin" type="number" step="1" min="1" max="100" name="deposit_percentage" value={deposit_percentage} onChange={this.handleChange} /> <div className="inline"> %</div>
                      </div>

                      <div className="row">
                        <HelpText page={'location_settings'} section={'deposit_threshold'} />
                        <label className="column checkbox-label block" htmlFor="deposit_threshold">Deposit Threshold</label>{ renderErrors(errors, 'deposit_threshold') }
                        £ <input className="column short-input small-bottom-margin" type="number" step="1" name="deposit_threshold" value={deposit_threshold} onChange={this.handleChange} /> <div className="inline"></div>
                      </div>
                    </>
                  )
                }
              </div>

              <div className="row">
                <HelpText page={'location_settings'} section={'hours_in_advance'} />
                <div className="inline">Bookings must be made at least </div><input className="column short-input" type="number" min="0" step="0.01" name="hours_in_advance" value={hours_in_advance} onChange={this.handleChange} /> <div className="inline"> Hours in advance</div>{ renderErrors(errors, 'hours_in_advance') }
              </div>

              <div className="row">
                <p>Your booking form has been enabled. Please direct your customers to this URL, which will be hosted on our website:</p>

                <input className="read-only" type="text" value={booking_form_urls.direct} readOnly />

                <p>Or, you can use the following code to embed it on your website:</p>

                <textarea className="read-only" rows="1" readOnly value={`<iframe src="${booking_form_urls.embedded}" width="1000" height="800"></iframe>`} />
              </div>
            </>
          )}
        </>
      )
    }
  }

  renderOpenHours() {
    const { selected_location, locationLoaded, errors } = this.state;

    if (locationLoaded === true && selected_location) {
      return (
        <div className="row">
          <HelpText page={'location_settings'} section={'open_hours'} />

          <label className="column">Open Hours:</label>{ renderErrors(errors, 'open_hours') }

          <table className="checkbox-table">
            <thead>
              <tr>
                <th>Day</th>
                <th>Open?</th>
                <th>Opening Time</th>
                <th>Closing Time</th>
              </tr>
            </thead>
            <tbody>
              {this.renderOpenHoursInputs("monday")}
              {this.renderOpenHoursInputs("tuesday")}
              {this.renderOpenHoursInputs("wednesday")}
              {this.renderOpenHoursInputs("thursday")}
              {this.renderOpenHoursInputs("friday")}
              {this.renderOpenHoursInputs("saturday")}
              {this.renderOpenHoursInputs("sunday")}
            </tbody>
          </table>
        </div>
      )
    }
  }

  renderSpecialHours() {
    const { special_hours, selected_location, locationLoaded, errors } = this.state;

    const length = special_hours ? Object.keys(special_hours).length : 0

    if (locationLoaded === true && selected_location) {
      return (
        <div className="row">
          <HelpText page={'location_settings'} section={'special_hours'} />

          <label className="column">Special Hours:</label>{ renderErrors(errors, 'special_hours') }
          <table className="checkbox-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Open?</th>
                <th>Opening Time</th>
                <th>Closing Time</th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              {this.state.special_hours.map((entry, index) => (
                this.renderSpecialHoursInputs(entry, index)
              ))}
            </tbody>
          </table>

          <button className="button small centered" onClick={this.handleAddDate}>Add {length === 0 ? "a" : "another"} date +</button>
        </div>
      )
    }
  }

  renderSaveButton() {
    if (this.state.locationLoaded === false) {
      return null
    }

    if (adminUser()) {
      return <> <input type="submit" value="Save" /> {this.state.updating === true && "Saving..."} </>
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }


  render() {
    const { selected_location, locations, locationsLoaded, unauthorized, errors, error } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (locationsLoaded === false) {
      return <p>Loading ...</p>;
    }

    if (locationsLoaded) {
      return (
        <form className="settings big-settings top-padding" onSubmit={this.handleSubmit}>
          <div className="row">
            <label className="column">Select a Location:</label>
            <select name="selected_location" onChange={this.handleChange} value={selected_location}>
              <option value="">Select</option>
              {locations.map((location) => (
                <option value={location.id} key={location.id}>{location.name}</option>
              ))}
            </select>
          </div>

          {this.renderBookingFormWarnings()}
          {this.renderBookingForm()}
          {this.renderOpenHours()}
          {this.renderSpecialHours()}

          <div className="row">
            { this.renderSaveButton() }
            { renderErrorWarning(errors) }
          </div>
        </form>
      )
    }
  }

  componentDidMount() {
    request("GET", `/v1/a/locations/names_and_ids`, "", () => {this.setState({unauthorized:true})})
      .then(data => {
        this.setState({ locations: data, locationsLoaded: true })

        if (data.length === 1) {
          const selected_location = data[0].id;
          this.setState({ selected_location: selected_location })
          this.fetchData(selected_location)
          this.bookingFormCheck(selected_location)
        }
      })
      .catch(error => handleRequestErrors(this, error, { locationsLoaded: true }))
  }
}

export default LocationSettings;
